import { useLocation, useParams } from "react-router-dom";
import { UrlImage } from "../../lib/api";
import { useState } from "react";

const ViewerPage = () => {
  const { state } = useLocation();
  const file = state?.file;
  const fileUrl = `${UrlImage}${file}`;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState("");

  return (
    // <iframe
    //   src={fileUrl}
    //   width="100%"
    //   height="100%"
    //   style={{
    //     border: "none",
    //     position: "absolute",
    //     top: 0,
    //     left: 0,
    //     right: 0,
    //     bottom: 0,
    //   }}
    //   title="Viewer"
    // />

    <div className="flex items-center justify-center h-screen">
      <form
        className="flex flex-col gap-4 p-8 rounded shadow-md w-full max-w-md"
        onSubmit={async (e) => {
          e.preventDefault();
          const prompt = e.target.elements.prompt.value;
          if (!prompt) return;
          setLoading(true);
          setError(null);
          setResult("");
          try {
            const response = await fetch(
              "https://api-inference.huggingface.co/models/gpt2",
              {
                method: "POST",
                headers: {
                  Authorization: "Bearer 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",
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({ inputs: prompt }),
              }
            );
            const data = await response.json();
            if (Array.isArray(data)) {
              setResult(data[0]?.generated_text || "No result");
            } else if (data?.generated_text) {
              setResult(data.generated_text);
            } else if (data?.error) {
              setError(data.error);
            } else {
              setResult(JSON.stringify(data));
            }
          } catch (err) {
            setError("Failed to fetch AI response.");
          } finally {
            setLoading(false);
          }
        }}
      >
        <label htmlFor="prompt" className="font-semibold">
          Enter your prompt:
        </label>
        <input
          id="prompt"
          name="prompt"
          type="text"
          className="border rounded px-3 py-2 focus:outline-none focus:ring w-full"
          placeholder="Type your prompt here..."
          required
        />
        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
          disabled={loading}
        >
          {loading ? "Generating..." : "Generate"}
        </button>
        {error && <div className="text-red-600 mt-2">{error}</div>}
        {result && (
          <div className="mt-4 p-3 rounded border whitespace-pre-wrap max-h-[50vh] overflow-auto">
            {result}
          </div>
        )}
      </form>
    </div>
  );
};

export default ViewerPage;
